
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.994 6A5.997 5.997 0 110 6a5.997 5.997 0 0111.994 0","fill":"#e6e6e6"}}),_c('g',{attrs:{"fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":".388"}},[_c('path',{attrs:{"d":"M5.003 9.57a.745.745 0 101.49 0 .745.745 0 00-1.49 0z"}}),_c('path',{attrs:{"d":"M5.749 8.82v-.861l.576-.576","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M.587 9.15a.745.745 0 101.49 0 .745.745 0 00-1.49 0zM7.647 10.36a.746.746 0 101.491 0 .746.746 0 00-1.491 0z"}}),_c('path',{attrs:{"d":"M7.616 7.38v.593l.776.776v.86","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.217 10.27a.745.745 0 11-1.49 0 .745.745 0 011.49 0z"}}),_c('path',{attrs:{"d":"M4.269 7.39v.5l-.776.775v.862M1.82 8.63l.776-.776v-.47","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.846 9.31a.745.745 0 101.49 0 .745.745 0 00-1.49 0z"}}),_c('g',{attrs:{"stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.298 7.38v.625l.776.776"}}),_c('path',{attrs:{"d":"M10.026 3.99c-.051 0-.1.003-.15.007a2.721 2.721 0 00-4.514-2.624 2.283 2.283 0 00-3.183 2.098v.017a1.954 1.954 0 00.164 3.902h7.683a1.7 1.7 0 000-3.4zM4.143 4.43a2.09 2.09 0 00-2.202-.91M9.925 2.88a2.085 2.085 0 01-.722 2.039"}})])])])
          )
        }
      }
    